/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect, useCallback} from 'react'
import {useGetCurrentUserQuery} from 'store/Store'
import storage from './storage'
import {Images} from 'appearance'
import qs from 'qs'

export * from 'react'
export {useNavigate} from 'react-router-dom'
export {useDispatch} from 'react-redux'
export {redirect} from 'react-router-dom'
export {useDebouncedCallback} from 'use-debounce'

export const qsStringify = (input) => qs.stringify(input)
export const useWindowSize = () => {
    const isClient = typeof window === 'object'

    const getSize = () => {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined,
        }
    }

    const [windowSize, setWindowSize] = useState(getSize)

    useEffect(() => {
        if (!isClient) {
            return false
        }

        function handleResize() {
            setWindowSize(getSize())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowSize
}

const getUrlParamsObject = () => {
    const searchParams = new URLSearchParams(window.location.search)
    const params = {}
    searchParams.forEach((v, k) => (params[k] = v))
    return params
}

const updateUrl = (key, val, refresh = false) => {
    const searchParams = new URLSearchParams(window.location.search)
    let searchStr = ''
    if (val) {
        searchParams.set(key, val)
        searchStr = `?${searchParams.toString()}`
    } else {
        searchParams.delete(key)
    }

    const {protocol, host, pathname} = window.location
    const newUrl = `${protocol}//${host}${pathname}${searchStr}`

    if (newUrl !== window.location.href && window.history.pushState) {
        window.history.pushState({path: newUrl}, '', newUrl)
    }
    return searchParams.toString()
}

export const useUrlParams = () => {
    const [urlParams, setUrlParams] = useState({})

    useEffect(() => {
        function handleUrlChange() {
            setUrlParams(getUrlParamsObject())
        }
        setUrlParams(getUrlParamsObject())
        window.addEventListener('popstate', handleUrlChange)

        return () => window.removeEventListener('popstate', handleUrlChange)
    }, [])

    const setUrlParam = useCallback((key, value) => {
        updateUrl(key, value)
        window.dispatchEvent(new Event('popstate'))
    }, [])

    return [urlParams, setUrlParam]
}

export const useUpdatedAccountImage = () => {
    const locallySavedImage = storage.getAccountImage()
    const {data: user} = useGetCurrentUserQuery('useUpdatedAccountImage')
    const userImage = user?.profileImageUrl

    if (locallySavedImage) {
        return locallySavedImage
    }
    if (userImage) {
        return userImage
    }
    return Images.USER_DEFUALT
}

export const getLayoutDirection = (isRtl) => (isRtl ? 'rtl' : 'ltr')
